import { SiteConfig } from "../../types";

export const _config: SiteConfig = {
  isDefault: false,
  showTidio: false,
  enableStripeBilling: false,
  serviceName: "Multilango.com",
  pwaServiceName: "Multilango",
  appLogoPath: "/partner/multilango/logo.png",
  appLogoHeight: "30px",
  landingLogoPath: "/partner/multilango/logo.png",
  landingLogoHeight: "30px",
  hubLogoPath: "/partner/multilango/logo.png",
  hubLogoHeight: "60px",
  favicon: "/partner/multilango/icon.png",
  pwaIcons: [
    {
      src: "/partner/multilango/icon.png",
      type: "image/png",
      sizes: "192x192",
    },
  ],
  overrideLanding: true,
  emailsSender: "info@lang-services.com",
  adminEmail: "hello@multilango.com",
  reviewLink: null,
  copyright: "Multilango",
  showLanguageGuides: true,
  bioPrompt: `
    You are a language tutor at Multilango.com.
  `,
  tocLink: "https://multilango.com/regulamin.pdf",
  privacyLink: "https://multilango.com/polityka_prywatnosci.pdf",
  fontLink: "/partner/multilango/fonts.css",
  fonts: {
    heading: `"Raleway", sans-serif`,
    body: `"Roboto", sans-serif`,
  },
  siteColors: {
    special: {
      desktopSidebar: "#fff",
      desktopSidebarBorderColor: "#ddd",
      desktopSidebarText: "#000",
      desktopSidebarTextHover: "#eee",
      chatAsideMenu: "#333",
      mobileNavBackgroundColor: "#333",
      mobileNavBackgroundContrastColor: "#ffffff",
      mobileNavBorderColor: "#333",
      speakInputIdle: "var(--chakra-colors-brand-tertiary-600)",
      speakInputRecording: "var(--chakra-colors-brand-tertiary-800)",
      speakInputRecordingCancel: "var(--chakra-colors-brand-tertiary-900)",
    },
  },
  colors: {
    primary: {
      main: "#455183",
      mainContrast: "#fff",
      "50": "#f7f7f9",
      "100": "#dee0e9",
      "200": "#c1c5d6",
      "300": "#9fa5bf",
      "400": "#8c93b2",
      "500": "#727ba1",
      "600": "#5d6793",
      "700": "#465284",
      "800": "#3b4570",
      "900": "#2a3250",
    },
    secondary: {
      main: "#EF7B6E",
      mainContrast: "#000",
      "100": "#fad9d5",
      "200": "#f6b6af",
      "300": "#f1897d",
      "400": "#e27468",
      "500": "#be6258",
      "600": "#a1534a",
      "700": "#81423b",
      "800": "#6d3832",
      "900": "#4f2924",
    },
    tertiary: {
      main: "#EF7B6E",
      mainContrast: "#000",
      "100": "#fad9d5",
      "200": "#f6b6af",
      "300": "#f1897d",
      "400": "#e27468",
      "500": "#be6258",
      "600": "#a1534a",
      "700": "#81423b",
      "800": "#6d3832",
      "900": "#4f2924",
    },
    gray: {
      "50": "#fafafa",
      "100": "#f1f1f1",
      "200": "#e7e7e7",
      "300": "#d4d4d4",
      "400": "#adadad",
      "500": "#7f7f7f",
      "600": "#545454",
      "700": "#373737",
      "800": "#202020",
      "900": "#191919",
    },
    red: {
      "50": "#fef5f4",
      "100": "#fad9d5",
      "200": "#f6b6af",
      "300": "#f1897d",
      "400": "#e27468",
      "500": "#be6258",
      "600": "#a1534a",
      "700": "#81423b",
      "800": "#6d3832",
      "900": "#4f2924",
    },
    orange: {
      "50": "#fefaf4",
      "100": "#faebd5",
      "200": "#f5d4a3",
      "300": "#e5b36a",
      "400": "#c69b5b",
      "500": "#aa854e",
      "600": "#907042",
      "700": "#725935",
      "800": "#5a4629",
      "900": "#4a3a22",
    },
    yellow: {
      "50": "#fefefa",
      "100": "#fcfae2",
      "200": "#f5f0a7",
      "300": "#ece36c",
      "400": "#d7cf63",
      "500": "#b1ab52",
      "600": "#8e8841",
      "700": "#6e6a33",
      "800": "#535026",
      "900": "#44421f",
    },
    green: {
      "50": "#f3fef9",
      "100": "#bbf7df",
      "200": "#6decb9",
      "300": "#61d2a5",
      "400": "#55b890",
      "500": "#499e7c",
      "600": "#3c8366",
      "700": "#2f6650",
      "800": "#265341",
      "900": "#1f4435",
    },
    teal: {
      "50": "#f0fcfd",
      "100": "#bcf2f8",
      "200": "#7be5f0",
      "300": "#64cdd9",
      "400": "#55aeb8",
      "500": "#48949c",
      "600": "#3a787f",
      "700": "#2d5d63",
      "800": "#264e52",
      "900": "#1f4043",
    },
    cyan: {
      "50": "#f4fbfe",
      "100": "#cfeefa",
      "200": "#b9e7f7",
      "300": "#9fdef4",
      "400": "#67c0e0",
      "500": "#5fb0ce",
      "600": "#559fb9",
      "700": "#468399",
      "800": "#3a6c7e",
      "900": "#2d5361",
    },
    blue: {
      "50": "#f1f6fe",
      "100": "#cddff9",
      "200": "#a9c8f5",
      "300": "#80adf1",
      "400": "#6595dc",
      "500": "#5780bd",
      "600": "#496b9e",
      "700": "#375279",
      "800": "#2d4363",
      "900": "#253650",
    },
    purple: {
      "50": "#f9f5fe",
      "100": "#e8d9fb",
      "200": "#d6bcf8",
      "300": "#bc92f3",
      "400": "#aa74f0",
      "500": "#895bc5",
      "600": "#724ca4",
      "700": "#5d3e86",
      "800": "#4c336e",
      "900": "#382551",
    },
    pink: {
      "50": "#fef5f9",
      "100": "#fbd8e6",
      "200": "#f7b7d1",
      "300": "#f289b4",
      "400": "#e76a9d",
      "500": "#bf5881",
      "600": "#a34b6f",
      "700": "#853d5a",
      "800": "#673046",
      "900": "#4c2333",
    },
  },
};
